// export const BACKEND_API_URL = "http://localhost:8000/api/v1";
// export const BACKEND_STORAGE_URL = "http://localhost:8000/storage";

export const BACKEND_API_URL = 'https://back-api.proalbrealestate.com/api/v1';
export const BACKEND_STORAGE_URL = 'https://back-api.proalbrealestate.com/storage';